// Сырое OSM-имя точки иногда - строка на уйгурском/китайском (приграничные
// вершины и перевалы). Показываем его, только если оно читается (латиница/
// кириллица); иначе - переведённое имя ru → en → kk, а если его нет - сырое.
const READABLE = /^[\p{Script=Latin}\p{Script=Cyrillic}\P{L}]*$/u;

export const isReadableScript = (s: string): boolean => READABLE.test(s);

export interface NameFields {
  name: string | null;
  name_ru: string | null;
  name_en: string | null;
  name_kk: string | null;
}

export const pickDisplayName = (d: NameFields): string => {
  if (d.name && isReadableScript(d.name)) return d.name;
  return d.name_ru || d.name_en || d.name_kk || d.name || "";
};

export interface LocalizedNames {
  ru: string | null;
  en: string | null;
  kk: string | null;
}

// Название точки на языке интерфейса: сначала перевод на этот язык, затем
// «сырое» имя OSM (если читается), затем остальные языки; в крайнем случае -
// сырое как есть. Порядок запасных: ru -> en -> kk, en -> ru -> kk, kk -> ru -> en.
export const pickLocalizedName = (names: LocalizedNames, raw: string, locale: string): string => {
  const own = (locale === "kk" ? "kk" : locale === "en" ? "en" : "ru") as keyof LocalizedNames;
  const others = (["ru", "en", "kk"] as const).filter((l) => l !== own);
  const readableRaw = raw && isReadableScript(raw) ? raw : "";
  return names[own] || readableRaw || names[others[0]] || names[others[1]] || raw || "";
};
